import { FieldError, UseFormReturn } from 'react-hook-form'

import {
  BusinessUnitTiny,
  CareerPathDto,
  CareerPathEvaluationState,
  Country,
  EmployeeDisplayTinyInfo,
  EmployeeLevelEnum,
  EmployeeTagType,
  PyramidForecastDto,
  PyramidForecastWithFiltersQuery,
} from '../../../types'

export enum ForeacastModalTabs {
  Employees = 'forecastModalTabEmployees',
  Hirings = 'forecastModalTabHirings',
}

interface FilterValues {
  employeeFullName: string
  businessUnitName: string
  currentEmployeeLevel: EmployeeLevelEnum
  careerPath: CareerPathEvaluationState
  tags: EmployeeTagType
}

export interface IForecastModalEmployeeTableField {
  levelChange?: EmployeeLevelEnum | null
  forecastDate?: string | null
  forecastEndDate?: string | null
}

export type ForecastModalEmployeeTableFields = 'levelChange' | 'forecastDate' | 'forecastEndDate' | ''

export interface IForecastModalEmployeeTableForm {
  [key: string]: {
    pastValue: IForecastModalEmployeeTableField
    currentValue: IForecastModalEmployeeTableField
    lastModifiedField: ForecastModalEmployeeTableFields
    hasErrors: ForecastModalEmployeeTableFields
  }
}

export type ForecastModalFilterValues = Partial<FilterValues>

export type ForecastModalHiringsFilterValues = {
  howMany: number
  level: EmployeeLevelEnum
  age: number
  bu: string
  dateOfLevelChange: string
}

export type ForecastModalNewHiring = {
  id: string
  key: string
  newHiringFullName?: string | null
  businessUnitId?: string
  salary?: number | null
  bonus?: number | null
  age?: number | null
  levelChange?: EmployeeLevelEnum | null
  dateOfLevelChange?: string | null
  isNewHiring?: boolean
}

export type ForecastModalHiringsTableValues = {
  hirings: ForecastModalNewHiring[]
}

export type ForecastModalHiringsTableErrors = {
  hirings?: {
    newHiringFullName?: FieldError
    businessUnitId?: FieldError
    salary?: FieldError
    bonus?: FieldError
    age?: FieldError
    levelChange?: FieldError
    dateOfLevelChange?: FieldError
  }[]
}

export interface ForecastModalState {
  pyramidForecastResponse: PyramidForecastDto[]
  employeeData: PyramidForecastDto[]
  newHiringsData: ForecastModalNewHiring[]
  employeeImmutableData: PyramidForecastDto[]
  employeeTableFormValues: IForecastModalEmployeeTableForm
  filterEmployees: EmployeeDisplayTinyInfo[]
  filterBu: BusinessUnitTiny[]
  filterEmployeeLevels: EmployeeLevelEnum[]
  isModalOpened: boolean
  activeTab: ForeacastModalTabs
  filterValues: ForecastModalFilterValues
  employeesSelectedRows: string[]
  hiringsSelectedRows: ForecastModalNewHiring[]
  hiringsTableForm: UseFormReturn<ForecastModalHiringsTableValues>
  deletedHirings: string[]
  employeeForecastHasChanges: boolean
  careerPath?: CareerPathDto[] | null
  options: {
    companyId: string
    country: string
  }

  resetStore: () => void
  setModalData: (data: PyramidForecastWithFiltersQuery) => void
  setEmployeeTableFormValues: (id: string, name: ForecastModalEmployeeTableFields, value: string | null) => void
  undoFormValues: (id: string) => void
  deleteEmployeesForecast: () => void
  toggleModal: (isModalOpened: boolean) => void
  toggleActiveTab: (activeTab: ForeacastModalTabs) => void
  setFilterValues: (filterValues: ForecastModalFilterValues) => void
  deleteFilter: (filterKey: keyof ForecastModalFilterValues) => void
  setEmployeeSelectedRows: (selectedRows: string[]) => void
  setHiringsSelectedRows: (selectedRows: ForecastModalNewHiring[]) => void
  setHiringsTableForm: (hiringsTableForm: UseFormReturn<ForecastModalHiringsTableValues, object>) => void
  setMultipleHiringsForDeletion: (ids: string[]) => void
  setOptions: ({ companyId, country }: { companyId: string; country: Country }) => void
}
